
/**
 * Taken from the description of the 'getFormatted' function in the following docs:
 * https://ppro-scripting.docsforadobe.dev/other/time.html?highlight=254016000000#time-object
 */
export const dropFrameRateToDisplayFormat = <const>{
  '30000/1001': 102,
  '60000/1001': 106,
};

export type PremiereDropFrameTimecodeDisplayFormat = typeof dropFrameRateToDisplayFormat[keyof typeof dropFrameRateToDisplayFormat];
